import GedocProtocolliList from "../gedocnotification/pages/GedocProtocolliList";
import GedocProtocolloView from "../gedocnotification/pages/GedocProtocolloView";

export default {
    GedocProtocolliList,
    GedocProtocolloView
};